import type { MouseEvent } from 'react'

import { classNames } from '@/utils/helpers'

import type { IconName } from './consts'
import { iconNames, iconsMap } from './consts'

interface Props {
  onChange: (icon: IconName, event: MouseEvent<HTMLDivElement>) => void
  icon?: string
}

const iconsOptions = iconNames.map((name) => {
  const Icon = iconsMap[name]

  return {
    value: name,
    label: <Icon className="h-4 w-4" />,
  }
})

export const IconPicker = ({ onChange, icon }: Props) => {
  return (
    <div className="flex max-h-[280px] max-w-[160px] flex-wrap justify-center overflow-auto lg:max-w-[280px]">
      {iconsOptions.map(({ label, value }) => (
        <div
          key={value}
          className={classNames('cursor-pointer rounded p-3', {
            'bg-primary-500 text-white': icon === value,
            'hover:bg-secondary-50': icon !== value,
          })}
          onClick={(event) => onChange(value, event)}
        >
          {label}
        </div>
      ))}
    </div>
  )
}
